import { app } from '../../../../../../app';
import { Controller } from './deactivate-sms.controller';

app.component('companyUserDirectoriesManageUserDetailsDeactivateSms', {
    bindings: {close: '&', dismiss: '&', resolve: '<'},
    controller: Controller,
    templateUrl: require('./deactivate-sms.html'),
});



// WEBPACK FOOTER //
// ./src/portal/states/company/user-directories/manage-user/details/deactivate-sms/deactivate-sms.component.js